import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteExoneradoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='EXONERADO' htmlFor='input-importeExonerado' md={6} alignRightAt='md' />
      <Col md={6}>
        <Form.InputNumber id='input-importeExonerado' name='input-importeExonerado' value={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteExoneradoFormGroup)
